import React from "react";
import {cs} from "@common/react/chain-services";
import "./manage-key/manage-access-key-dialog.scss";
import {DialogService} from "../../../../common/dialog/dialog-service";
import {Button} from "../../../../../../../common/form/buttons/button/button";
import {VerbDialogBodyScrollbar} from "@common/ui-components/verb-scrollbar/verb-dialog-body-scrollbar";

export const CannotCreateApiKeyDialog = ({next: rootNext}) =>
    cs(
        [
            "modal",
            (_, next) =>
                DialogService({
                    render: ({resolve}) => ({
                        title: "Cannot Create New Key",
                        width: 480,
                        content: next({
                            resolve,
                        }),
                        initShow: true,
                        className: "manage-access-key-dialog-wrapper-a23",
                    }),
                    next: rootNext,
                }),
        ],
        ({modal}) => (
            <div className="manage-access-key-dialog-z33">
                <VerbDialogBodyScrollbar>
                    <div className="key-description">
                        To create a Data Access API Key, this environment must have the authentication method's response parameters configured. Please add response parameters and
                        try again.
                    </div>
                </VerbDialogBodyScrollbar>

                <div className="buttons">
                    <Button btnType="secondary" onClick={() => modal.resolve()}>
                        Cancel
                    </Button>
                    <Button onClick={() => modal.resolve(true)}>Go To Auth Setup</Button>
                </div>
            </div>
        )
    );
